export type CookieConsentChoice = "essential" | "analytics"

export const COOKIE_CONSENT_STORAGE_KEY = "adi-cookie-consent-v1"

export const COOKIE_PREFERENCES_OPEN_EVENT = "adi-cookie-preferences-open"

export function getStoredCookieConsent(): CookieConsentChoice | null {
  if (typeof window === "undefined") {
    return null
  }
  const raw = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY)
  if (raw === "essential" || raw === "analytics") {
    return raw
  }
  return null
}

export function setStoredCookieConsent(choice: CookieConsentChoice): void {
  if (typeof window === "undefined") {
    return
  }
  window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, choice)
}

export function openCookiePreferences(): void {
  if (typeof window === "undefined") {
    return
  }
  window.dispatchEvent(new Event(COOKIE_PREFERENCES_OPEN_EVENT))
}
